var _path, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoLocationsSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 73,
    viewBox: "0 0 48 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.8135 72.1273C30.3565 73.3098 26.293 73.231 23.647 71.9697L8.99957 64.875C6.44808 63.6137 6.25908 61.643 8.71607 60.4606C11.1731 59.2781 15.2366 59.3569 17.8826 60.6182L32.53 67.7129C35.176 68.9742 35.2705 70.9449 32.8135 72.1273Z",
    fill: "url(#paint0_linear_411_44490)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9101 35.3458C47.9101 40.0758 46.5801 43.9058 44.1001 46.2458C44.1001 46.2458 43.5801 46.7358 43.5101 46.7958L34.2401 54.0658L29.0701 58.1158L28.9901 58.1558L18.9701 63.9658L30.8901 54.6158L33.4201 52.6358C33.5001 52.5758 34.0101 52.0858 34.0101 52.0858C34.6501 51.4758 35.2101 50.7758 35.7001 49.9758C37.0901 47.6958 37.8201 44.6858 37.8201 41.1758C37.8201 38.0458 37.2401 34.7358 36.2101 31.4458C34.3101 25.3758 30.8401 19.3758 26.5401 14.6858C25.4301 13.4658 24.2501 12.3458 23.0401 11.3258C21.7101 10.2158 20.3301 9.23584 18.9101 8.41584C17.1001 7.37584 15.3501 6.66584 13.7001 6.25584C10.7101 5.51584 8.03009 5.78584 5.84009 6.93584L15.5101 1.33584L15.7401 1.20584C15.7401 1.20584 15.8101 1.16584 15.8401 1.14584C19.2401 -0.704157 23.8801 -0.374156 29.0001 2.57584C30.4101 3.39584 31.7901 4.37584 33.1201 5.48584C41.5801 12.5458 47.9001 24.9058 47.9101 35.3358V35.3458Z",
    fill: "url(#paint1_linear_411_44490)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9 64.0058L18.94 63.9858L18.9 64.0058Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.21 31.4558C34.31 25.3858 30.84 19.3858 26.54 14.6958C25.43 13.4758 24.25 12.3558 23.04 11.3358C21.71 10.2258 20.33 9.2458 18.91 8.4258C17.1 7.3858 15.35 6.6758 13.7 6.2658C10.71 5.5258 8.03 5.7958 5.84 6.9458L5.23 7.3058C1.99 9.3558 0.01 13.5058 0 19.3458C0 20.9558 0.149999 22.6458 0.459999 24.3758C1.04 27.7158 2.18 31.2258 3.81 34.6458C3.81 34.6458 4.33 35.7258 4.41 35.8858L13.22 52.9758L18.91 64.0058L18.95 63.9858L30.87 54.6258L33.4 52.6458C33.48 52.5858 33.99 52.0958 33.99 52.0958C34.63 51.4858 35.19 50.7858 35.68 49.9858C37.07 47.7058 37.8 44.6958 37.8 41.1858C37.8 38.0558 37.22 34.7458 36.19 31.4558H36.21ZM22.85 39.0458C21.74 39.3058 20.38 39.0458 18.91 38.2058C15.11 36.0158 12.03 30.6758 12.03 26.2958C12.03 23.8058 13.02 22.1558 14.57 21.5958C15.75 21.1658 17.26 21.3758 18.9 22.3258C22.7 24.5158 25.78 29.8558 25.78 34.2358C25.78 36.9258 24.62 38.6358 22.85 39.0458Z",
    fill: "#D7D7D7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.78 34.2358C25.78 36.9258 24.62 38.6358 22.85 39.0458C21.74 39.3058 20.38 39.0458 18.91 38.2058C15.11 36.0158 12.03 30.6758 12.03 26.2958C12.03 23.8058 13.02 22.1558 14.57 21.5958C15.75 21.1658 17.26 21.3758 18.9 22.3258C22.7 24.5158 25.78 29.8558 25.78 34.2358Z",
    fill: "url(#paint2_linear_411_44490)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_411_44490",
    x1: 20.7441,
    y1: 74.6274,
    x2: 27.3195,
    y2: 61.0715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#525252",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_411_44490",
    x1: 6,
    y1: 6,
    x2: 38,
    y2: 53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.211673,
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.425569,
    stopColor: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.550544,
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.709325,
    stopColor: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8A8A8",
    stopOpacity: 0.68
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_411_44490",
    x1: 14.04,
    y1: 21.8458,
    x2: 23.77,
    y2: 38.6858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#B9B9B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#D5D5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8A8A8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoLocationsSvg);
export default __webpack_public_path__ + "static/media/no_locations_svg.2f833123abe59d72be90bc4af6d0b830.svg";
export { ForwardRef as ReactComponent };